module.exports = __webpack_public_path__ + "static/media/gryphon-house-transform-4.42ba28d6.jpeg";